import { FT_TO_INCHES } from '../classes/math.utilities';
import { DEFAULT_PLATE, IPlateLoc } from './pitches/i-plate-loc';

/** units in feet */
export interface IStrikeZone {
  /** height of hitter in inches, without decimals, for finding strike zone closest to player's height */
  height_in: number;

  bottom_ft: number;
  top_ft: number;
  left_ft: number;
  right_ft: number;

  // middle of the strikezone
  plate_ft: IPlateLoc;
}

export const PLATE_WIDTH_IN = 17;
export const STRIKEZONE_HEIGHT_IN = 19.5;
export const BALL_DIAMETER_IN = 2.94;

export const getStrikezone = (config: {
  plate: IPlateLoc;
  widthIn: number;
  heightIn: number;
}): IStrikeZone => {
  const halfWidthFt = config.widthIn / 2 / FT_TO_INCHES;
  const halfHeightFt = config.heightIn / 2 / FT_TO_INCHES;

  const output: IStrikeZone = {
    /** default, height is irrelevant but shouldn't match anything */
    height_in: config.heightIn / FT_TO_INCHES,

    bottom_ft: config.plate.plate_z - halfHeightFt,
    top_ft: config.plate.plate_z + halfHeightFt,

    left_ft: config.plate.plate_x - halfWidthFt,
    right_ft: config.plate.plate_x + halfWidthFt,

    plate_ft: config.plate,
  };

  return output;
};

// for plots and aiming widgets
export const VISIBLE_STRIKEZONE = getStrikezone({
  plate: DEFAULT_PLATE,
  widthIn: PLATE_WIDTH_IN,
  heightIn: STRIKEZONE_HEIGHT_IN,
});

/**
 * index 0 = player height in inches
 * index 1 = strike zone top in inches
 * index 2 = strike zone bottom in inches
 */
const STRINGER_TABLE: number[][] = [
  // [60, 40.3, 20.4],
  [65, 38, 17.3],
  [66, 36.4, 16.8],
  [67, 40.4, 18.6],
  [68, 38.6, 17.9],
  [69, 39.3, 18.1],
  [70, 39.7, 18.3],
  [71, 39.8, 18.3],
  [72, 40.4, 18.7],
  [73, 41, 18.9],
  [74, 41.7, 19.4],
  [75, 42.3, 19.7],
  [76, 42.7, 20],
  [77, 43.2, 20.2],
  [78, 43.4, 20.4],
  [79, 44.7, 21],
  [80, 44.1, 20.5],
  [81, 44.7, 20.8],
  [82, 47.8, 22.6],
  [83, 48.1, 22.1],
];

export const STRINGER_STRIKEZONES: IStrikeZone[] = STRINGER_TABLE.map(
  ([_, szTopIn, szBottomIn]) => {
    const szMiddleIn = (szTopIn + szBottomIn) / 2;

    return getStrikezone({
      plate: {
        plate_x: 0,
        plate_z: szMiddleIn / FT_TO_INCHES,
      },
      widthIn: PLATE_WIDTH_IN + BALL_DIAMETER_IN,
      heightIn: szTopIn - szBottomIn + BALL_DIAMETER_IN,
    });
  }
);
